import { NzSafeAny } from 'ng-zorro-antd/core/types';

export interface AlainACLConfig {
  /**
   * Router URL when guard fail, default: `/403`
   */
  guard_url?: string;

  /**
   * `can` before execution callback
   */
  preCan?: ((roleOrAbility: number | number[] | string | string[] | AlainACLType) => AlainACLType | null) | null;
}

export interface AlainACLType {
  /**
   * è§è²
   */
  role?: string[];
  /**
   * æéç¹
   */
  ability?: number[] | string[];

  /**
   * æ ¡éªæ¨¡å¼ï¼é»è®¤ï¼`oneOf`
   * - `allOf` è¡¨ç¤ºå¿é¡»æ»¡è¶³ææè§è²ææéç¹æ°ç»ç®ææ
   * - `oneOf` è¡¨ç¤ºåªé¡»æ»¡è¶³è§è²ææéç¹æ°ç»ä¸­çä¸é¡¹ç®ææ
   */
  mode?: 'allOf' | 'oneOf';

  /**
   * æ¯å¦ååï¼å³ç»æä¸º `true` æ¶è¡¨ç¤ºæªææ
   */
  except?: boolean;

  [key: string]: NzSafeAny;
}
